import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=b5c41e12&scoped=true&"
import script from "./HelpIcon.vue?vue&type=script&lang=ts&"
export * from "./HelpIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c41e12",
  null
  
)

export default component.exports